import { ExtendedFile } from 'types';

class FileService {
  public parseFileProps = (newFile: File): ExtendedFile => {
    const fileNameArray = newFile.name.split('.');
    let fileName;
    let extension;
    if (fileNameArray.length > 1) {
      fileName = fileNameArray.slice(0, -1).join('.');
      extension = fileNameArray.pop() || '';
    } else {
      fileName = newFile.name;
      extension = '';
    }

    return {
      originalFile: newFile,
      addedAt: new Date(),
      name: fileName,
      extension,
      size: newFile.size,
    };
  };

  public parseMultipleFiles = (files: File[]) => files.map((file) => this.parseFileProps(file));
}

export default new FileService();
